export default __webpack_public_path__ + "static/game-development-4722d5788c59ebc82d0f0fc1a962625b.webp";